module.exports = ".file-uploadnew label {\r\n    padding: 10px;\r\n    display: table;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n    background: #fff;\r\n    color: #000;\r\n    font: size 22px;\r\n    border: 1px solid #b9b9b9;\r\n    cursor: pointer;\r\n  }\r\n  .file-upload label i {\r\n    margin-right: 8px;\r\n  }\r\n  .file-upload input[type=\"file\"] {\r\n    display: none;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/chaptertest/chaptertest.component.css
// module id = ./src/app/chaptertest/chaptertest.component.css
// module chunks = main